export type Language = {
	id?: number;
	uuid: string;
	name: string;
	code: string;
};
